










































import ivyPlayer from '../../commons/ivyPlayer.vue'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {
    ivyPlayer,
  },
})
export default class SpellGroup extends Vue {
  @Prop() spuData: any
  @Prop() goldShow: any
  pageIndex: number = 1
  videoPlaying: boolean = false
  newTime: any
  spuId: any
  timer: string = ''
  async created() {}
  pageChange(index) {
    this.pageIndex = index + 1
  }
  playVideo() {
    // 播放视频
    this.videoPlaying = true
    ;(document.querySelector('.ivy-btn-play') as any).click()
  }
  closeVideo() {
    // 关闭播放
    this.videoPlaying = false
    this.newTime = new Date().getTime()
  }
}
